import locale from "date-fns/esm/locale/en-IN";

export const getWeekdays = () =>
  // 0 = Sunday, put last
  [1, 2, 3, 4, 5, 6, 0].map(i =>
    locale?.localize?.day(i, { width: "abbreviated", startOfWeek: 1 })
  );
